import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isBotTyping: false,
  isUserTyping: false,
  messages: [],
};

const chatReducer = createSlice({
  name: "chats",
  initialState,
  reducers: {
    setIsBotTyping: (state, { payload }) => {
      state.isBotTyping = payload;
    },
    setIsUserTyping: (state, { payload }) => {
      state.isUserTyping = payload;
    },
    setMessages: (state, { payload }) => {
      state.messages = payload;
    },
  },
});

export const { setIsBotTyping, setMessages, setIsUserTyping } =
  chatReducer.actions;

export default chatReducer.reducer;
